import React from "react";
import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useLang } from "@/LanguageContext";
import { TARIFS } from "@/lib/clientData";
import { Check } from "lucide-react";

const scrollToContact = () => {
  window.location.href = "/#contact";
};

export default function Tarifs() {
  const { lang } = useLang();
  const isFr = lang === "fr";
  return (
    <div className="bg-navy min-h-screen">
      <Navbar />
      <section className="pt-40 pb-16 max-w-[1400px] mx-auto px-6 md:px-10 text-center">
        <div className="flex justify-center items-center gap-4 mb-6">
          <span className="tricolore"><span className="bg-frblue" /><span className="bg-white" /><span className="bg-frred" /></span>
          <span className="text-gold text-xs tracking-luxe uppercase">{isFr ? "Tarifs" : "Pricing"}</span>
        </div>
        <h1 className="font-serif-lux text-white text-4xl sm:text-5xl lg:text-6xl font-light">
          {isFr ? "L'Art Français du Voyage de Luxe" : "The French Art of Luxury Travel"}
        </h1>
        <p className="text-gold-light tracking-luxe uppercase text-xs mt-5">
          {isFr ? "Excellence · Discrétion · Perfection" : "Excellence · Discretion · Perfection"}
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-28 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {TARIFS.map((p, i) => (
          <motion.div
            key={p.key}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.08 }}
            data-testid={`tarif-${p.key}`}
            className={`relative flex flex-col p-8 border ${p.featured ? "border-gold bg-white/[0.04]" : "border-gold/20"}`}
          >
            {p.featured && (
              <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-navy text-[10px] tracking-luxe uppercase px-3 py-1">
                {isFr ? "Le Plus Prisé" : "Most Coveted"}
              </span>
            )}
            <h2 className="font-serif-lux text-gold-light text-3xl">{p.name}</h2>
            <p className="text-white/60 text-sm font-light italic mt-2 min-h-[40px]">{isFr ? p.taglineFr : p.taglineEn}</p>
            <div className="gold-line w-full my-6 opacity-40" />
            <ul className="space-y-3 flex-1">
              {(isFr ? p.fr : p.en).map((f, j) => (
                <li key={j} className="flex gap-3 text-white/80 text-sm font-light">
                  <Check className="h-4 w-4 text-gold shrink-0 mt-0.5" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            {p.tiers ? (
              <div className="mt-6 space-y-2">
                {p.tiers.map((t) => (
                  <div key={t.price} className="flex justify-between items-baseline border-t border-gold/15 pt-2">
                    <span className="text-white/70 text-sm">{isFr ? t.fr : t.en}</span>
                    <span className="font-serif-lux text-gold-light text-xl">{t.price}</span>
                  </div>
                ))}
                <p className="text-white/40 text-xs mt-2">{isFr ? p.footnoteFr : p.footnoteEn}</p>
              </div>
            ) : (
              <div className="mt-6">
                <p className="text-white/40 text-[10px] tracking-luxe uppercase">{isFr ? "À partir de" : "From"}</p>
                <p className="font-serif-lux text-white text-4xl mt-1">{p.price || (isFr ? p.priceFr : p.priceEn)}</p>
                <p className="text-white/40 text-[10px] tracking-luxe uppercase mt-1">{isFr ? p.unitFr : p.unitEn}</p>
              </div>
            )}

            <button
              onClick={scrollToContact}
              data-testid={`tarif-cta-${p.key}`}
              className={`btn-lux mt-7 py-3 text-xs tracking-luxe uppercase ${p.featured ? "bg-gold text-navy hover:bg-gold-light" : "border border-gold/50 text-gold hover:bg-gold hover:text-navy"}`}
            >
              {isFr ? "Réserver" : "Enquire"}
            </button>
          </motion.div>
        ))}
      </section>
      <Footer />
    </div>
  );
}
